/* eslint-disable */
/**
 * GENERATED FILE. DO NOT EDIT.
 * Source: shared/src/speech/speakableText.ts
 * Edit the source, then run `node scripts/sharedSync.js`.
 * `npm run audit:all` fails while this copy differs from its source.
 */
/**
 * Whether a string is worth sending to text-to-speech.
 *
 * WHY THIS EXISTS
 *   The failures dashboard collected 340 TTS_SYNTHESIS_FAILED reports in two
 *   days, and every single one was a request for text with nothing in it to
 *   pronounce: ",", "。", "→", ".", "·", ",,,". No Edge voice can render those,
 *   so the backend failed every attempt and logged a 500 for what is really a
 *   no-op.
 *
 *   They were never authored — they are what is left between two matches when a
 *   mixed-script string is split for speech ("가다 → 갔다" leaves "→"; "가요,
 *   갔어요" leaves ","). So the guard belongs at every place that produces a
 *   speech chunk, and again at the point a request URL is built, rather than at
 *   any one call site.
 *
 * A voice needs at least one letter or digit, in any script.
 */
const SPEAKABLE_RE = /[\p{L}\p{N}]/u;
export function isSpeakable(text) {
    return SPEAKABLE_RE.test(String(text || ''));
}
/**
 * Drop the chunks a voice cannot render from a list of speech chunks.
 * `getText` reads the text off a chunk (defaults to `chunk.text`).
 */
export function keepSpeakable(chunks, getText = (chunk) => chunk?.text) {
    return (Array.isArray(chunks) ? chunks : []).filter((chunk) => isSpeakable(getText(chunk)));
}
export default isSpeakable;
